// 消息推送
<template>
  <div class="container socket" v-if="$route.name!=='Login'">
    <div
      class="message-wrao-allow"
      :class="{ 'is-shrink': isShrink, 'is-not-shrink': !isShrink }"
      v-if="msgList.length"
      @click="isShrink = !isShrink"
    >
      <!-- <i class="icon-allow iconfont iconjiantou-zhankai"></i> -->
      <i class="icon-allow el-icon-arrow-left"></i>
    </div>
    <el-scrollbar
      class="message-wrap"
      :class="{ 'no-height': !msgList.length, 'is-shrink': isShrink, 'is-not-shrink': !isShrink }"
    >
      <div
        class="massage-bar"
        @click="isShrink = false"
      >
        {{$lang('未读信息')}}({{total > 99 ? 99 : total}})
        <i class="icon-iconfont iconfont iconxinxi"></i>
      </div>
      <ul
        class="message-wrap-ul strong"
        infinite-scroll-disabled="false"
        infinite-scroll-distance="50"
        :infinite-scroll-immediate-check="true"
      >
        <li
          class="message-row"
          v-for="(item, index) in msgList"
          :key="index"
          :data-priority="item.priority"
        >
          <div class="message-row-wrap">
            <p class="row-header">
              <span class="header-left">
                <span class="title ellipsis">【{{item.type===2?item.title:'公告通知'}}】</span>
              </span>
              <span class="header-right">{{item.messageTime}}</span>
            </p>
            <div class="row-body">
              <div v-if="item.type!==2" class="row-body--item row-body-text-container">
                <p>
                  <span>{{'公告名称'}}：</span>
                  <span class="ellipsis">{{item.title}}</span>
                </p>
                <p>
                  <span>{{'公示时间'}}：</span>
                  <span class="ellipsis">{{item.showDayStart+'-'+item.showDayEnd}}</span>
                </p>
              </div>
              <div v-else class="row-body--item row-body-text-container">
                <span class="ellipsis">{{item.contentName}}</span>
                <span class="ellipsis">{{item.contentValue}}</span>
              </div>
              <!-- showType 是否显示查看详情和我知道了按钮 1-是 2-否 -->
              <p
                class="row-body--item row-footer"
                v-if="item.showType !== 2"
              >
                <button
                  class=""
                  @click="toMessagePage(index,item)"
                >{{$lang('查看')}}</button>
                <button
                  class="confirm"
                  @click="confirm(index,item)"
                >{{$lang('知道了')}}</button>
              </p>
            </div>
          </div>
        </li>
      </ul>
    </el-scrollbar>
    <PreviewInfo v-if="previewVisible" :visible.sync="previewVisible" :id="previewId"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { publicApi } from '@/common/api/public';
export default {
  data() {
    return {
      // 提示列表
      // total: ,
      // 收缩状态 false展开 true收缩
      isShrink: false,
      msgList: [],
      timer: null,
      formData: {},
      total: 0,
      previewVisible: false,
      previewId: ''
    }
  },
  computed: {
    ...mapGetters({
      user: 'user',
      token: 'token'
    })
  },
  mounted() {
    console.log(this.$route.name, '44444444444444444');

    this.token && this.openTimer()
  },
  watch: {
    token() {
      if (!this.token) {
        this.closeTimer()
        return
      }
      this.openTimer()
    }
  },
  methods: {
    ...mapActions({
      delView: 'tags/delView'
    }),
    toMessagePage(index, { type, id, jumpType, jumpModuleId, customerJumpLink }) {
      if (type === 1) {
        this.previewId = id
        this.previewVisible = true
      } else {
        if (this.$route.name === 'CustomerServiceCenter') this.$router.push({ path: '/index' })
        this.$router.push({ name: 'CustomerServiceCenter', path: '/CustomerServiceCenter',
          params: {
            jumpModuleId, jumpType,
            sourceType: 'notice', // 培训
            customerJumpLink
          }})
      }
      this.$nextTick(() => {
        this.confirm(index, { type, id })
      })
    },
    async confirm(index, { id, type }) {
      this.msgList.splice(index, 1)
      await publicApi.reqMarkRead({ userCode: this.user.code, messageId: id, type })
      if (!this.msgList.length) this.geUnread()
    },
    // 开启定时器
    openTimer() {
      this.closeTimer()
      this.geUnread()
      this.timer = setInterval(() => {
        this.geUnread()
      }, 300000)
    },
    // 关闭定时器
    closeTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    async geUnread() {
      this.msgList = []
      if (!this.token) return
      const { data, code } = await publicApi.geUnread({
        userCode: this.user.code
      })
      if (code === 1) {
        this.total = data?.total
        this.msgList = (data?.msgList || []).map(o => {
          if (o.type === 2) {
            const contentList = o.content?.split('\n') || []
            return { ...o, contentName: contentList[0], contentValue: contentList[1] }
          }
          return o
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$ft14: 14px;
$ft12: 12px;
$ft10: 10px;
$h16: 16px;
.socket {
  position: fixed;
  top: 0;
  right: 0;
  // height: 100%;
  width: 440px;
  z-index: 1020;
  .message-wrap:before {
    content: '';
    position: absolute;
    width: 4px; // 边框的宽度
    height: 44px;
    left: -1px; //距离 view 标签的距离
    top: 56px;
    z-index: 1002;
    @include bg-color('pop');
  }
  .message-wrap {
    overflow-x: hidden;
    position: fixed;
    right: 11px;
    top: 60px;
    height: 180px;
    z-index: 1001;
    border-radius: 4px;
    // transition: transform .3s;
    @include shadow-color();
    border-width: 1px;
    border-style: solid;
    @include border-color('lighter');
    background-color: white;
    &.bottom {
      top: auto;
      bottom: 10px;
    }
    &.no-height {
      display: none;
    }
    .massage-bar {
      display: none;
      width: 32px;
      text-align: center;
      padding: 10px 4px;
      box-sizing: border-box;
      @include bg-color('pop');
      @include text-color('brand');
      position: absolute;
      z-index: 1;
      height: 100%;
      line-height: 150%;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      > .icon-iconfont {
        margin: auto;
        position: relative;
        top: 20px;
      }
    }
    &.is-shrink {
      .massage-bar {
        display: block;
      }
    }
  }
  .is-shrink {
    transform: translateX(400px);
    transition: transform 0.3s;
  }
  .is-not-shrink {
    transform: translateX(0);
    transition: transform 0.3s;
  }
  .message-wrao-allow {
    // overflow: hidden;
    position: fixed;
    right: 432px;
    top: 116px;
    width: 12px;
    z-index: 1009;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 44px;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    -webkit-transform: perspective(16px) rotateY(-20deg);
    -webkit-transform-origin: right;
    -moz-transform: perspective(16px) rotateY(-20deg);
    -moz-transform-origin: right;
    transform: perspective(16px) rotateY(-20deg);
    transform-origin: right;
    @include bg-color('pop');
    border-width: 1px;
    border-style: solid;
    border-right: none;
    @include border-color('lighter');
    cursor: pointer;
    transition: transform 0.3s;
    .icon-allow {
      display: inline-block;
      /* position: relative;
      top: 17px; */
      // font-size: 12px;
      @include icon-color('routine');
      margin-left: 2px;
      font-size: 12px;
      @include text-color('subtitle');
      transform: rotate(180deg); // scale(0.5);
      // -webkit-transform: scale(0.5);
      // @include icon-color('routine');
    }
    &.is-shrink {
      // right: 30px;
      .icon-allow {
        @include text-color('brand');
      }
      transition: transform 0.3s;
      transform: translateX(400px) perspective(12px) rotateY(-20deg);
      .icon-allow {
        transform: rotate(0deg); // scale(0.5);
      }
    }
    &.is-not-shrink {
      // transition: transform .2s;
      transition: transform 0.3s;
      transform: translateX(0) perspective(12px) rotateY(-20deg);
      .icon-allow {
        transform: rotate(180deg); // scale(0.5);
      }
    }
  }
  .message-wrap-ul {
    width: 420px;
    @include bg-color('pop');
    margin-top: 0;
    padding-left: 0;
    &.strong {
      min-height: 162px;
    }
    .el-scrollbar__wrap {
      overflow-x: hidden !important;
      .el-scrollbar__bar.is-horizontal {
        display: none;
      }
    }
    .message-row {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      height: 91px;
      padding: 0 14px;
      // margin-bottom: 10px;
      color: $c-fc-3;
      font-size: $ft12;
      @include bg-color('pop');
      &:last-child {
        border-bottom: none;
      }
      .ellipsis {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-break: break-all;
      }
    }
    .message-row-wrap {
      padding: 14px 0;
      border-bottom: 1px solid #dcdee1;
    }
    .row-header {
      display: flex;
      justify-content: space-between;
      > span {
        display: block;
      }
    }
    .title {
      // color: $c-fc-1;
      font-weight: bold;
      font-size: $ft14;
      max-width: 270px;
      display: inline-block;
      @include text-color('subtitle');
    }
    p {
      margin: 0;
    }
    .row-body {
      margin-top: 6px;
      line-height: 28px;
      display: flex;
      justify-content: space-between;
      .row-body-text-container {
        display: inline-block;
        flex: 1;
        line-height: 18px;
        overflow: hidden;
        .ellipsis {
          display: inline-block;
          width: 100%;
        }
        & > p {
          display: flex;
          white-space: nowrap;
          & > span:nth-child(2) {
            // width: 50%;
          }
        }
        .link {
          color: $-color-brand;
          cursor: pointer;
        }
      }
      .row-body--item {
        padding-left: 8px;
      }
    }
    .row-footer {
      // position: absolute;
      // bottom: 10px;
      // right: 14px;
      width: 140px;
      text-align: right;
      button {
        box-sizing: border-box;
        width: 60px;
        height: 28px;
        padding: 0;
        margin-left: 10px;
        text-align: center;
        border-radius: $radius-base;
        outline: none;
        border-width: 1px;
        border-style: solid;
        background-color: transparent;
        @include text-color('routine');
        @include border-color('base');
        &:hover {
          cursor: pointer;
        }
        // &.normal {
        //   border: 1px solid $c-fc-3;
        //   background-color: $c-nc-1;
        // }
        &.confirm {
          color: $-color-brand;
          border-color: $-color-brand;
          // border: none;
          // background-color: $blue-color;
          // @include base-color('bg');
        }
      }
    }
  }
}
.socket {
  .socket-alert {
    box-shadow: none !important;
  }
}
.socket-alert {
  .sa-head {
    color: #fff;
    height: 40px;
    font-size: 14px;
    font-weight: bold;
    background: #e60012;
    padding: 0 9px;
    line-height: 40px;
    .sa-head-title {
      color: #fff;
    }
    .sa-head-time {
      font-size: 12px;
      font-weight: 400;
    }
  }
  .sa-body {
    width: 400px;
    height: 100%;
    height: 80px;
    overflow-y: auto;
    margin: 0 auto;
    word-break: break-all;
    padding: 10px 0;
    box-sizing: border-box;
  }
  .sa-foot {
    position: absolute;
    right: 20px;
    bottom: 6px;
    &.row-footer {
      width: 200px;
      button {
        width: 80px;
      }
    }
  }
}
</style>
<style lang="scss">
.socket {
  .el-scrollbar__wrap {
    overflow-x: hidden !important;
  }
  .el-scrollbar__bar.is-vertical {
    width: 8px;
  }
  .el-scrollbar__bar.is-vertical .el-scrollbar__thumb {
    width: 8px;
  }
  .el-scrollbar__bar .el-scrollbar__thumb {
    border-radius: 8px;
  }
}
</style>
